"use client";

import {FC, useContext} from "react";
import type {FieldErrorProps, TextProps} from "react-aria-components";
import {FieldError, Text, FieldErrorContext} from "react-aria-components";
import {faCircleExclamation} from "@fortawesome/free-solid-svg-icons/faCircleExclamation";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import clsMerge from "../../util/clsMerge";

type HelperTextClasses = {
	default?: string;
	error?: string;
	errorIcon?: string;
};

type HelperTextProps = {
	classes?: HelperTextClasses;
	helperText?: React.ReactNode | string;
	hideErrors?: boolean;
	errorProps?: FieldErrorProps;
	textProps?: TextProps;
};

const FormHelperText: FC<HelperTextProps> = ({
	classes,
	helperText,
	hideErrors,
	errorProps,
	textProps,
}) => {
	const errorContext = useContext(FieldErrorContext);

	return (
		<div>
			{helperText && !errorContext?.isInvalid && (
				<Text
					className={clsMerge("pl-1 text-sm text-gray-800", classes?.default)}
					slot="description"
					{...textProps}
				>
					{helperText}
				</Text>
			)}
			{!hideErrors && (
				<div className="flex flex-row items-start gap-2">
					{errorContext?.isInvalid && (
						<FontAwesomeIcon
							className={clsMerge(
								"flex-none pt-1 text-semantic-error-300",
								classes?.errorIcon
							)}
							icon={faCircleExclamation}
						/>
					)}
					<FieldError
						className={clsMerge(
							"pt-0.5 text-sm text-semantic-error-500",
							classes?.error
						)}
						{...errorProps}
					/>
				</div>
			)}
		</div>
	);
};

export default FormHelperText;

export type {HelperTextClasses};
